module.exports = __webpack_public_path__ + "img/logo-rossignol.36991cd6.svg";